<template>
	<v-app>
		<div v-if="!isMobile()">
			<v-dialog v-model="dialogAbout" width="600">
				<v-card>
					<v-toolbar class="text-center" color="green" dark>Sobre</v-toolbar>
					<v-card-text>
						<div class="text-subtitle-1 text-left pt-4">Desenvolvedor:</div>
						<div class="text-body-2 text-left">Filippo Maio</div>
						<div class="text-subtitle-1 text-left pt-4">Orientador:</div>
						<div class="text-body-2 text-left">Sérgio Serra</div>
						<div class="text-subtitle-1 text-left pt-4">Coorientador:</div>
						<div class="text-body-2 text-left">Gabriel Compto</div>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn text @click="dialogAbout = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogLoading" persistent fullscreen content-class="loading-dialog">
				<v-container fill-height>
					<v-layout class="row justify-center align-center flex-column">
						<h1 class="color-loading">Aguarde...</h1>
						<v-progress-circular indeterminate :size="70" :width="7" color="green"></v-progress-circular>
					</v-layout>
				</v-container>
			</v-dialog>
			<v-dialog v-model="dialogConfirma" persistent width="600">
				<v-card>
					<v-toolbar class="text-center" color="green" dark>Confirmação</v-toolbar>
					<v-card-text>
						<div class="text-subtitle-1 text-left pt-4">Essa observação já possui imagem</div>
						<div class="text-subtitle-1 text-left">Deseja alterar a imagem por esta nova?</div>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn text @click="dialogConfirma = false">Não</v-btn>
						<v-btn text @click="doUpload()">Sim</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogObrigatorio" width="600">
				<v-card>
					<v-toolbar class="text-center" color="green" dark>Aviso!</v-toolbar>
					<v-card-text>
						<div class="text-subtitle-1 text-left pt-4">É necessário o preenchimento de todos os campos</div>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn text @click="dialogObrigatorio = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-app-bar id="app-bar" absolute app color="transparent" flat height="20"></v-app-bar>
			<v-navigation-drawer id="core-navigation-drawer" dark app left width="260" src="../assets/sidebar.jpg">
				<template v-slot:img="props">
					<v-img :gradient="`to bottom, rgba(35, 20, 10, .9), rgba(35, 20, 10, .9)`" v-bind="props" />
				</template>
				<v-divider class="mb-1" />
				<v-list dense nav>
					<v-list-item>
						<v-list-item-avatar class="ml-13" rounded height="120" width="120">
							<v-img src="../assets/logoVR.png" max-height="300" />
						</v-list-item-avatar>
					</v-list-item>
				</v-list>
				<v-divider class="mb-2" />
				<v-list expand nav class="ma-3">
					<div />
					<v-list-item href="#" rel="noopener" target="undefined" to="/" active-class="">
						<v-list-item-icon>
							<v-icon>mdi-map-marker</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="text-left">Mapa</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item href="#" rel="noopener" target="undefined" to="/admin" active-class="">
						<v-list-item-icon>
							<v-icon>mdi-cloud-upload</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="text-left">Upload de Imagem</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<div />
				</v-list>

				<template v-slot:append>
					<v-list-item>
						<v-list-item-content>
							<v-row>
								<v-col>
									<v-btn height="70px" href="https://r1.ufrrj.br/petsi/" target="_blank" text><img src="../assets/logo-pet.png" width="70px"/></v-btn>
									<v-btn height="70px" href="https://portal.ufrrj.br/" target="_blank" text><img src="../assets/logo-rural.png" width="70px"/></v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-btn height="40px" text @click="dialogAbout = true"><img src="../assets/easteregg.png" width="40px"/></v-btn>
								</v-col>
							</v-row>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-navigation-drawer>
			<v-content>
				<v-container>
					<v-card class="px-5 py-3">
						<v-sheet class="pa-4 text-center mt-n6" color="green" elevation="6" dark>
							<div class="display-1">Upload de Imagem 360º</div>
						</v-sheet>
						<v-card-text class="px-0 mt-5">
							<v-row class="justify-center">
								<v-col cols="4" class="justify-center">
									<v-row>
										<v-select v-model="selectProjeto" :items="projetos" label="Projetos" outlined item-value="id_projeto" item-text="nome" @change="getObservacoes"></v-select>
									</v-row>
									<v-row>
										<v-select v-model="selectObservacao" :items="cenarios" label="Observações" outlined item-value="id_observacao" item-text="identificacao_campo" @change="getObservacao"></v-select>
									</v-row>
									<v-row>
										<v-textarea :value="cenarioTexto" label="Dados da Observação" readonly outlined></v-textarea>
									</v-row>
									<v-row>
										<v-col>
											<v-text-field dense disabled v-model="imageName" outlined></v-text-field>
										</v-col>
										<v-col>
											<v-btn @click="pickFile">Escolher imagem</v-btn>
											<input type="file" ref="image" accept="image/*, video/*" @change="onFilePicked" />
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions class="justify-center">
							<v-btn @click="limparCampos()">Limpar</v-btn>
							<!--v-btn dark color="green" class="ml-5" @click="upload({ imageName: imageName, imageFile: imageFile, cenarioOpenSoils: cenario })">Enviar</v-btn-->
							<v-btn dark color="green" class="ml-5" @click="checkImage()">Enviar</v-btn>
						</v-card-actions>
					</v-card>
				</v-container>
			</v-content>
			<!--
		<v-footer id="dashboard-core-footer" color="#362e14">
			<v-container>

			</v-container>
		</v-footer>
		-->
		</div>
		<div v-else>
			<v-app-bar dark color="#362E14" fixed>
				<v-app-bar-title>
					OpenSoils VR
				</v-app-bar-title>
				<v-spacer></v-spacer>
				<v-btn color="#324413" href="#" rel="noopener" target="undefined" to="/">Voltar ao Mapa</v-btn>
			</v-app-bar>
			<v-content class=" overflow-y-auto">
				<v-container>
					<v-card class="px-5 py-3 ">
						<v-sheet class="pa-4 text-center mt-13" color="green" elevation="6" dark>
							<div class="display-1">Upload de Imagem 360º</div>
						</v-sheet>
						<v-card-text class="px-0 mt-5">
							<v-row class="justify-center">
								<v-col class="justify-center">
									<v-row>
										<v-select v-model="selectProjeto" :items="projetos" label="Projetos" outlined item-value="id_projeto" item-text="nome" @change="getObservacoes"></v-select>
									</v-row>
									<v-row>
										<v-select v-model="selectObservacao" :items="cenarios" label="Observações" outlined item-value="id_observacao" item-text="identificacao_campo" @change="getObservacao"></v-select>
									</v-row>
									<v-row>
										<v-textarea :value="cenarioTexto" label="Dados da Observação" readonly outlined></v-textarea>
									</v-row>
									<v-row>
										<v-col>
											<v-text-field dense disabled v-model="imageName" outlined></v-text-field>
										</v-col>
										<v-col>
											<v-btn @click="pickFile">Escolher imagem</v-btn>
											<input type="file" ref="image" accept="image/*, video/*" @change="onFilePicked" />
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions class="justify-center">
							<v-btn @click="limparCampos()">Limpar</v-btn>
							<!--v-btn dark color="green" class="ml-5" @click="upload({ imageName: imageName, imageFile: imageFile, cenarioOpenSoils: cenario })">Enviar</v-btn-->
							<v-btn dark color="green" class="ml-5" @click="checkImage()">Enviar</v-btn>
						</v-card-actions>
					</v-card>
				</v-container>
			</v-content>
		</div>
	</v-app>
</template>

<script>
// @ is an alias to /src
//import Upload from "@/components/upload.vue";
import { mapActions, mapState } from "vuex";

export default {
	name: "Admin",
	components: {},
	data() {
		return {
			imageName: "",
			imageUrl: "",
			imageFile: "",
			pressed: false,
			consulta: "",
			center: { lat: -13.43, lng: -53.98 },
			dialogAbout: false,
			podeUpload: false,
			cenarioTexto: "",
			dialogLoading: false,
			dialogConfirma: false,
			dialogObrigatorio: false,
			selectProjeto: 0,
			selectObservacao: 0,
		};
	},
	async created() {
		//this.getCenario("CVDWda8ujk9PwrqWqxii");
	},
	async mounted() {
		await this.getProjetos();
	},
	methods: {
		...mapActions(["getCenario", "upload", "getCenariosByProjeto", "getProjetos", "getCenarioByIdOpenSoils"]),

		//Escolher arquivo para anexar
		pickFile() {
			this.$refs.image.click();
			this.pressed = true;
		},

		//Anexar arquivo selecionado
		onFilePicked(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				this.imageName = files[0].name;
				if (this.imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.imageUrl = fr.result;
					this.imageFile = files[0];
				});
			} else {
				this.imageName = "";
				this.imageFile = "";
				this.imageUrl = "";
			}
		},
		isMobile() {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				return true;
			} else {
				return false;
			}
		},
		async getObservacoes(id) {
			await this.getCenariosByProjeto(id);
		},

		async getObservacao(id) {
			await this.getCenario(id);
			let desc = "";
			if (this.cenario.descricao.sibics_atual) desc += "Classificação: " + this.cenario.descricao.sibics_atual + "\n";
			if (this.cenario.descricao.localizacao) desc += "Localização: " + this.cenario.descricao.localizacao + "\n";
			if (this.cenario.descricao.valor_pedregosidade) desc += "Pedregosidade: " + this.cenario.descricao.valor_pedregosidade + "\n";
			if (this.cenario.descricao.valor_rochosidade) desc += "Rochosidade: " + this.cenario.descricao.valor_rochosidade + "\n";
			if (this.cenario.descricao.valor_drenagem) desc += "Drenagem: " + this.cenario.descricao.valor_drenagem + "\n";
			if (this.cenario.descricao.vegetacao_primaria) desc += "Vegetação Primária: " + this.cenario.descricao.vegetacao_primaria + "\n";
			if (this.cenario.descricao.situacao_declive) desc += "Situação Declive:" + this.cenario.descricao.situacao_declive + "\n";
			if (this.cenario.descricao.formacao_geologica) desc += "Formação Geológica: " + this.cenario.descricao.formacao_geologica + "\n";
			if (this.cenario.descricao.litologia) desc += "Litologia: " + this.cenario.descricao.litologia + "\n";
			if (this.cenario.descricao.material_originario) desc += "Material Originário: " + this.cenario.descricao.material_originario + "\n";
			if (this.cenario.descricao.relevo.relevo_local) desc += "Relevo Local: " + this.cenario.descricao.relevo.relevo_local + "\n";
			if (this.cenario.descricao.relevo.relevo_regional) desc += "Relevo Regional: " + this.cenario.descricao.relevo.relevo_regional + "\n";
			if (this.cenario.descricao.erosoes[0].forma_erosao) desc += "Forma Erosão: " + this.cenario.descricao.erosoes[0].forma_erosao + "\n";
			if (this.cenario.descricao.uso_atual) desc += "Uso Atual: " + this.cenario.descricao.uso_atual + "\n";
			if (this.cenario.descricao.descrito_coletado) desc += "Descrito por: " + this.cenario.descricao.descrito_coletado + "\n";
			this.cenarioTexto = desc;
		},

		async checkImage() {
			if (this.imageName != "" && this.imageFile != "" && this.imageUrl != "" && this.cenario.id_observacao && this.selectProjeto > 0 && this.selectObservacao > 0) {
				this.dialogLoading = true;
				await this.getCenarioByIdOpenSoils(this.cenario.id_observacao);
				if (this.cenarioVR.imagem) {
					this.dialogConfirma = true;
				} else {
					await this.upload({ imageName: this.imageName, imageFile: this.imageFile, cenarioOpenSoils: this.cenario });
				}
				this.dialogLoading = false;
			} else {
				this.dialogObrigatorio = true;
			}
		},

		async doUpload() {
			this.dialogLoading = true;
			await this.upload({ imageName: this.imageName, imageFile: this.imageFile, cenarioOpenSoils: this.cenario });
			this.dialogLoading = false;
			this.dialogConfirma = false;
		},

		limparCampos() {
			this.imageName = "";
			this.imageFile = "";
			this.imageUrl = "";
			this.selectProjeto = 0;
			this.selectObservacao = 0;
			this.cenarioTexto = "";
		},
	},
	computed: {
		...mapState(["cenario", "projetos", "cenarios", "cenarioVR"]),

		getHome() {
			return window.location.host;
		},
		getTamanhoMapa() {
			return "width: 100%; height: 98vh";
		},
	},
};
</script>

<style>
input[type="file"] {
	display: none;
}
.image {
	width: 400px;
	max-width: 100%;
}
.fullscreen {
	height: 98vh;
	position: relative;
}

/*html,
body {
	overflow-y: auto;
}*/

.v-list-item--active {
	color: white;
	background-color: green;
}
</style>
